import { render, staticRenderFns } from "./lookLicense.vue?vue&type=template&id=9aea808c&"
import script from "./lookLicense.vue?vue&type=script&lang=js&"
export * from "./lookLicense.vue?vue&type=script&lang=js&"
import style0 from "./lookLicense.vue?vue&type=style&index=0&id=9aea808c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports